import React from "react";
import AdditionalFieldInput from "./AdditionalFieldInput";
import { buildFieldKey } from "./useSectionEvaluation";

const SimpleAdditionalFieldsBlock = ({
    matchedFields,
    sectionFields,
    isLocked,
    isFieldInvalid,
    onFieldChange,
    onFieldComment,
    onFieldBlur,
    isFieldRequired,
}) => {
    if (!matchedFields.length) return null;

    return (
        <div className="row">
            <div className="form-block">
                {matchedFields.map((field) => {
                    const fieldId = field.sgbpAdditionalFieldInputId;
                    const key = buildFieldKey(fieldId, null);
                    const fState = sectionFields?.[key];
                    const required = isFieldRequired ? isFieldRequired(field?.sgbpRequirementId, field.isRequired) : field.isRequired; // fallback

                    return (
                        <React.Fragment key={fieldId}>
                            <div className="left">
                                <label>
                                    {field?.label ?? ""} {required  && <span className="red-star">*</span>}
                                </label>
                                <label className="mt-4 instruction-content">
                                    <div dangerouslySetInnerHTML={{ __html: field?.addtionalFieldIntruction || "" }} />
                                </label>
                            </div>
                            <div className="right">
                                <AdditionalFieldInput
                                    field={field}
                                    value={fState?.value}
                                    invalid={isFieldInvalid(key, field.isRequired, field?.sgbpRequirementId)}
                                    isLocked={isLocked}
                                    onChange={(val) => onFieldChange(fieldId, val, field?.sgbpRequirementId)}
                                    onBlur={() => onFieldBlur(key)}
                                />
                                <textarea
                                    disabled
                                    placeholder=""
                                    value={fState?.comment || ""}
                                    onChange={(e) => onFieldComment(fieldId, e.target.value, field?.sgbpRequirementId)}
                                    style={isLocked ? { background: "#f5f5f5", cursor: "not-allowed" } : {}}
                                />
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default SimpleAdditionalFieldsBlock;